
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#8CC677","fill-opacity":".15"}}),_c('path',{attrs:{"d":"M7.011 11.571L3.714 8.165l.923-.919 2.357 2.402 3.976-3.979.959.902-4.918 5z","fill":"#459A43"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"15","height":"15","rx":"7.5","stroke":"#459A43","stroke-opacity":".8"}})])
          )
        }
      }
    